<script setup lang="ts">
const content = {
  cta: {
    title: 'Klaar om de beste makelaar te vinden?',
    description: 'Vergelijk makelaars in jouw regio en bespaar op courtagekosten.',
    button: 'Vergelijk makelaars',
  },
  logo: {
    title: 'Onze makelaars zijn aangesloten bij:',
  },
  socials: {
    links: [
      { label: 'Facebook', href: 'https://www.facebook.com/juistemakelaar', icon: 'i-simple-icons-facebook' },
      { label: 'Instagram', href: 'https://www.instagram.com/huisassist_', icon: 'i-simple-icons-instagram' },
      { label: 'LinkedIn', href: 'https://www.linkedin.com/company/huisassist', icon: 'i-simple-icons-linkedin' },
    ],
  },
  trustpilot: {
    href: 'https://nl.trustpilot.com/review/juistemakelaar.nl',
  },
}

const cities = {
  label: 'Steden',
  children: [
    { label: 'Den Haag', href: '/makelaars/zuid-holland/den-haag/' },
    { label: 'Amsterdam', href: '/makelaars/noord-holland/amsterdam/' },
    { label: 'Rotterdam', href: '/makelaars/zuid-holland/rotterdam/' },
    { label: 'Utrecht', href: '/makelaars/utrecht/utrecht/' },
    { label: 'Breda', href: '/makelaars/noord-brabant/breda/' },
    { label: 'Groningen', href: '/makelaars/groningen/groningen/' },
    { label: 'Nijmegen', href: '/makelaars/gelderland/nijmegen/' },
    { label: 'Tilburg', href: '/makelaars/noord-brabant/tilburg/' },
    { label: 'Zwolle', href: '/makelaars/overijssel/zwolle/' },
    { label: 'Eindhoven', href: '/makelaars/noord-brabant/eindhoven/' },
    { label: 'Haarlem', href: '/makelaars/noord-holland/haarlem/' },
    { label: 'Amersfoort', href: '/makelaars/utrecht/amersfoort/' },
    { label: 'Almere', href: '/makelaars/flevoland/almere/' },
    { label: 'Enschede', href: '/makelaars/overijssel/enschede/' },
    { label: 'Arnhem', href: '/makelaars/gelderland/arnhem/' },
    { label: 'Dordrecht', href: '/makelaars/zuid-holland/dordrecht/' },
    { label: 'Den-Bosch', href: '/makelaars/noord-brabant/den-bosch/' },
    { label: 'Maastricht', href: '/makelaars/limburg/maastricht/' },
    { label: 'Apeldoorn', href: '/makelaars/gelderland/apeldoorn/' },
    { label: 'Leiden', href: '/makelaars/zuid-holland/leiden/' },
    { label: 'Alkmaar', href: '/makelaars/noord-holland/alkmaar/' },
    { label: 'Zaandam', href: '/makelaars/noord-holland/zaandam/' },
    { label: 'Zeist', href: '/makelaars/utrecht/zeist/' },
    { label: 'Alle plaatsen', href: '/makelaars/' },
  ],
}

const links = [
  {
    label: 'Huis verkopen',
    children: [
      { label: 'Overzicht makelaars Nederland', href: '/makelaar/' },
      { label: 'Wat kost een verkoopmakelaar?', href: '/tip/kosten-verkoopmakelaar/' },
      { label: 'Hoe vergelijk je makelaars?', href: '/tip/makelaars-vergelijken/' },
      { label: 'Stappenplan succesvol je huis verkopen', href: '/tip/stappenplan-huis-verkopen/' },
      { label: 'Taken verkoopmakelaar', href: '/tip/taken-verkoopmakelaar/' },
      { label: 'Dubbele woonlasten, wat nu?', href: '/tip/twee-huizen-dubbele-woonlasten/' },
      { label: 'Huis verkopen belasting', href: '/tip/huis-verkopen-belasting/' },
      { label: 'Hoe je huis snel verkopen', href: '/huis-verkopen/' },
      { label: 'Tips om de beste makelaar te vinden', href: '/tip/' },
    ],
  },
  {
    label: 'Huis kopen',
    children: [
      { label: 'Hoe ga jij een aankoopmakelaar vergelijken?', href: '/tip/aankoopmakelaar-vergelijken/' },
      { label: 'Kosten aankoopmakelaar', href: '/tip/kosten-aankoopmakelaar/' },
      { label: 'Taken aankoopmakelaar', href: '/tip/taken-aankoopmakelaar/' },
      { label: 'Het stappenplan om een huis te kopen', href: '/tip/stappenplan-huis-kopen/' },
      { label: 'Kosten Koper (k.k.)', href: '/tip/kosten-koper/' },
      { label: 'De betekenis van onder bod', href: '/tip/onder-bod/' },
      { label: 'Een geschikte taxateur vinden', href: '/taxateur/' },
      { label: 'Soorten woningen', href: '/type-woning/' },
    ],
  },
  {
    label: 'Over ons',
    children: [
      { label: 'Home', href: '/' },
      { label: 'Voor makelaars', href: '/aanmelden-voor-makelaars/' },
      { label: 'Nieuws', href: '/nieuws/' },
      { label: 'Over ons', href: '/over-ons/' },
      { label: 'Contact', href: '/contact/' },
      { label: 'Werken bij Juiste Makelaar', href: '/werken-bij/' },
    ],
  },
  {
    label: 'Info',
    children: [
      { label: 'Jodenbreestraat 25', href: null },
      { label: '1011 NH Amsterdam', href: null },
      { label: '020 244 2818', href: 'tel:0202442818' },
      { label: 'info@juistemakelaar.nl', href: 'mailto:info@juistemakelaar.nl' },
      { label: 'KvK: 83403647', href: null },
    ],
  },
]
</script>

<template>
  <footer>
    <!-- CTA band -->
    <div class="relative bg-primary-950 overflow-hidden">
      <img
        src="/img/graphics/arrows-blue.svg"
        class="absolute -right-10 -top-10 w-[400px] opacity-[0.08] pointer-events-none select-none"
        alt=""
        aria-hidden="true"
        loading="lazy"
      >
      <UContainer class="relative py-12 text-center">
        <h2 class="text-2xl sm:text-3xl font-bold tracking-[-0.015em] text-white text-balance mb-3">
          {{ content.cta.title }}
        </h2>
        <p class="text-white/60 text-pretty mb-6 max-w-lg mx-auto">
          {{ content.cta.description }}
        </p>
        <UButton
          :label="content.cta.button"
          to="/vergelijk-verkoop/"
          color="secondary"
          size="xl"
          trailing-icon="i-brand-arrow-alt"
        />
      </UContainer>
    </div>

    <!-- Main footer -->
    <div class="bg-neutral-950 pt-16 pb-8">
      <UContainer>
        <!-- Logo + Socials row -->
        <div class="flex flex-col sm:flex-row sm:items-center sm:justify-between gap-4 mb-12">
          <div class="flex flex-col gap-3">
            <img
              src="/img/logos/juistemakelaar/white.svg"
              alt="JuisteMakelaar"
            >
            <NuxtLink
              :to="content.trustpilot.href"
              target="_blank"
              rel="noopener"
              class="flex gap-1 items-center text-sm text-white/60 hover:text-white/70 transition-colors"
            >
              <UIcon
                v-for="i in 5"
                :key="i"
                name="i-lucide-star"
                class="text-yellow-500 size-3.5"
              />
              <span class="ml-1">4,5 / 5 op Trustpilot</span>
            </NuxtLink>
          </div>

          <div class="flex gap-1">
            <UButton
              v-for="link in content.socials.links"
              :key="link.label"
              :icon="link.icon"
              :aria-label="link.label"
              color="neutral"
              variant="ghost"
              class="!text-white/60 hover:!text-white hover:!bg-white/10"
              :to="link.href"
              target="_blank"
              rel="noopener"
            />
          </div>
        </div>

        <!-- Link columns -->
        <div class="space-y-10 md:grid md:grid-cols-4 md:gap-8 md:space-y-0 mb-12">
          <div
            v-for="column in links"
            :key="column.label"
          >
            <h3 class="text-sm font-semibold text-white mb-4">
              {{ column.label }}
            </h3>
            <ul
              role="list"
              class="space-y-3"
            >
              <li
                v-for="link in column.children"
                :key="link.label"
                class="text-sm"
              >
                <NuxtLink
                  v-if="link.href"
                  :to="link.href"
                  class="text-white/60 hover:text-white transition-colors"
                >{{ link.label }}</NuxtLink>
                <span
                  v-else
                  class="text-white/60"
                >{{ link.label }}</span>
              </li>
            </ul>
          </div>
        </div>

        <!-- Branche logos -->
        <div class="border-t border-white/10 pt-8 mb-8">
          <div class="mx-auto max-w-xl">
            <h2 class="text-center text-sm font-medium text-white/60 mb-4">
              {{ content.logo.title }}
            </h2>
            <div class="flex flex-wrap md:flex-nowrap gap-6 justify-center items-center">
              <NuxtImg
                class="max-h-6 md:max-h-8 w-auto object-contain brightness-0 invert opacity-40"
                src="/img/footer/logos/branche_1.webp"
                alt="NVM branchevereniging"
              />
              <img
                class="max-h-8 md:max-h-10 w-auto object-contain opacity-40"
                src="/img/footer/logos/vastgoed-nederland.svg"
                alt="Vastgoed Nederland"
                loading="lazy"
              >
            </div>
          </div>
        </div>

        <!-- Cities -->
        <div class="border-t border-white/10 pt-8 mb-8">
          <h3 class="text-sm font-semibold text-white mb-4">
            {{ cities.label }}
          </h3>
          <ul
            role="list"
            class="flex gap-x-3 gap-y-2 flex-wrap"
          >
            <li
              v-for="(city, index) in cities.children"
              :key="city.label"
              class="text-sm flex items-center gap-3"
            >
              <NuxtLink
                :to="city.href"
                class="text-white/60 hover:text-white transition-colors"
              >{{ city.label }}</NuxtLink>
              <span
                v-if="index < cities.children.length - 1"
                class="text-white/15"
              >&middot;</span>
            </li>
          </ul>
        </div>

        <!-- Copyright -->
        <div class="border-t border-white/10 pt-6">
          <p class="text-xs text-white/50">
            &copy; 2026 Juiste Makelaar. Alle rechten voorbehouden.
          </p>
        </div>
      </UContainer>
    </div>
  </footer>
</template>
